export class DeleteCompanyModel { 
    public companyId : string;
}